import { UserShort } from './user.interface';

export type DocumentsSortKey =
  | 'title_asc'
  | 'title_desc'
  | 'newest_first'
  | 'oldest_first';

export const DOCUMENTS_SORT_KEYS: readonly DocumentsSortKey[] = [
  'title_asc',
  'title_desc',
  'newest_first',
  'oldest_first'
] as const;

export const DEFAULT_DOCUMENTS_SORT: DocumentsSortKey = 'title_asc';

export interface FlDocument extends BasicDocument {
  id: number;
  filename: string;
  user: UserShort;
  can_delete: boolean;
  can_create: boolean;
  show_in_participation_page: boolean;
  /** The folder the document is filed in. Absent for documents outside any folder. */
  category?: { id: number; name: string; show_in_participation_page?: boolean };
  /** Write only: moves the document; null is the top level. */
  category_id?: number | null;
  origin_type?: string | null;
  origin_id?: number | null;
  created_at: string;
  updated_at: string;
}

export interface BasicDocument {
  id: number | string;
  content_type: string;
  title: string;
  url: string;
  updated_at?: string;
}

export interface DocumentFilterParams {
  origin_id?: number;
  origin_type?: string;
  category_id?: number;
  q?: string;
  sort?: DocumentsSortKey;
  /**
   * Tri-state on the API: omit for every document, true for the participation
   * ("Mitwirkung") view only, false for the normal documents view only.
   */
  show_in_participation_page?: boolean;
}
